module.exports = __webpack_public_path__ + "static/fcra-2020-21-q4-a3c173694f20d0d5f9b76418e6c8d6a5.pdf";